/* tslint:disable:indent */
import {Preference} from './../model/preference';
import {Endpoints} from './../../../../models/endpoints';
import {environment} from 'src/environments/environment';
import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {SessionService} from '../../../administration/services/session.service';
import {NavigationEnd, Router} from '@angular/router';
import {Diffuseur} from '../../../../models/diffuseur';
import { HttpService } from '../../../shared/services/http.service';

@Injectable({
  providedIn: 'root'
})
export class PreferencesService {

  private isPrefActivated: boolean = false;
  private previousUrl: string = undefined;
  private currentUrl: string = undefined;

  public getPreviousUrl() {
    return this.previousUrl;
  }

  constructor(private http: HttpService, private session: SessionService, private router: Router) {
    this.isPrefActivated = environment.pref === 'true';
    this.currentUrl = this.router.url;
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
      }
    });
  }

  public displayPreference(): boolean {
    return this.isPrefActivated;
  }

  // partage preference
  public getCodePreference(id: number): Observable<Preference> {
    if (!this.isPrefActivated) {
      return of(new Preference());
    }
    return this.http.get(
      Endpoints.PREFERENCE_PARTAGE_RECUP_CODE
      + Endpoints.PREFERENCE_SIRET
      + this.session.getUser()?.siret
      + Endpoints.PREFERENCE_SERVICE
      + this.session.getUser()?.service
      + Endpoints.PREFERENCE_AND_ID
      + id,
      Preference
    );
  }

  public copyPreference(code: string): Observable<Preference> {
    if (!this.isPrefActivated) {
      return of(new Preference());
    }
    return this.http.get(
      Endpoints.PREFERENCE_PARTAGE_COPY
      + Endpoints.PREFERENCE_SIRET
      + this.session.getUser()?.siret
      + Endpoints.PREFERENCE_SERVICE
      + this.session.getUser()?.service
      + Endpoints.PREFERENCE_PARTAGE_CODE
      + Endpoints.PREFERENCE_RAISON_SOCIALE
      + this.session.getUser()?.raisonSociale
      + code,
      Preference
    );
  }

  // preference facturation
  public createFacturation(preference: Preference): Observable<Preference> {
    if (!this.isPrefActivated) {
      return of(new Preference());
    }
    const body = preference;
    return this.http.post(
       Endpoints.PREFERENCE_FACTURATION
      + Endpoints.PREFERENCE_SIRET
      + this.session.getUser()?.siret
      + Endpoints.PREFERENCE_SERVICE
      + this.session.getUser()?.service
      + Endpoints.PREFERENCE_RAISON_SOCIALE
      + this.session.getUser()?.raisonSociale
      , body
      , Preference
    );
  }

  public updateFacturation(preference: Preference): Observable<Preference> {
    if (!this.isPrefActivated) {
      return of(new Preference());
    }
    const body = preference;
    return this.http.put(
      Endpoints.PREFERENCE_FACTURATION
      , body
      , Preference
    );
  }

  public getFullFacturation(): Observable<Preference[]> {
    if (!this.isPrefActivated) {
      return of([new Preference()]);
    }
    return this.http.get<Preference[], Preference>(
      Endpoints.PREFERENCE_FACTURATION_FULL
      + Endpoints.PREFERENCE_SIRET
      + this.session.getUser()?.siret
      + Endpoints.PREFERENCE_SERVICE
      + this.session.getUser()?.service,
      Preference
    );
  }

  public getlightFacturation(): Observable<Preference[]> {
    if (!this.isPrefActivated) {
      return of([new Preference()]);
    }
    return this.http.get<Preference[], Preference>(
      Endpoints.PREFERENCE_FACTURATION_LIGHT
      + Endpoints.PREFERENCE_SIRET
      + this.session.getUser()?.siret
      + Endpoints.PREFERENCE_SERVICE
      + this.session.getUser()?.service,
      Preference
    );
  }

  public getByIdFacturation(id: number): Observable<Preference> {
    if (!this.isPrefActivated) {
      return of(new Preference());
    }
    return this.http.get(
      Endpoints.PREFERENCE_FACTURATION
      + '/' + id,
      Preference
    );
  }

  public deleteFacturation(id: number): Observable<any> {
    if (!this.isPrefActivated) {
      return of(null);
    }
    return this.http.delete(
      Endpoints.PREFERENCE_FACTURATION
      + Endpoints.PREFERENCE_ID
      + id
    );
  }

  // preference compte annonceur
  public createAnnonceur(preference: Preference): Observable<Preference> {
    if (!this.isPrefActivated) {
      return of(new Preference());
    }
    const body = preference;
    return this.http.post(
      Endpoints.PREFERENCE_ANNONCEUR
      + Endpoints.PREFERENCE_SIRET
      + this.session.getUser()?.siret
      + Endpoints.PREFERENCE_SERVICE
      + this.session.getUser()?.service
      + Endpoints.PREFERENCE_RAISON_SOCIALE
      + this.session.getUser()?.raisonSociale
      , body
      , Preference
    );
  }

  public updateAnnonceur(preference: Preference): Observable<Preference> {
    if (!this.isPrefActivated) {
      return of(new Preference());
    }
    const body = preference;
    return this.http.put(
      Endpoints.PREFERENCE_ANNONCEUR
      , body
      , Preference
    );
  }

  public getFullAnnonceur(): Observable<Preference[]> {
    if (!this.isPrefActivated) {
      return of([new Preference()]);
    }
    return this.http.get<Preference[], Preference>(
      Endpoints.PREFERENCE_ANNONCEUR_FULL
      + Endpoints.PREFERENCE_SIRET
      + this.session.getUser()?.siret
      + Endpoints.PREFERENCE_SERVICE
      + this.session.getUser()?.service
      , Preference
    );
  }

  public getlightAnnonceur(): Observable<Preference[]> {
    if (!this.isPrefActivated) {
      return of([new Preference()]);
    }
    return this.http.get<Preference[], Preference>(
      Endpoints.PREFERENCE_ANNONCEUR_LIGHT
      + Endpoints.PREFERENCE_SIRET
      + this.session.getUser()?.siret
      + Endpoints.PREFERENCE_SERVICE
      + this.session.getUser()?.service
      , Preference
    );
  }

  public getByIdAnnonceur(id: number): Observable<Preference> {
    if (!this.isPrefActivated) {
      return of(new Preference());
    }
    return this.http.get(
      Endpoints.PREFERENCE_ANNONCEUR
      + '/' + id
      , Preference
    );
  }

  public deleteAnnonceur(id: number): Observable<any> {
    if (!this.isPrefActivated) {
      return of(null);
    }
    return this.http.delete(
      Endpoints.PREFERENCE_ANNONCEUR
      + Endpoints.PREFERENCE_ID
      + id
    );
  }

  // preference cpv
  public createCpv(preference: Preference): Observable<Preference> {
    if (!this.isPrefActivated) {
      return of(new Preference());
    }
    const body = preference;
    return this.http.post(
      Endpoints.PREFERENCE_CPV
      + Endpoints.PREFERENCE_SIRET
      + this.session.getUser()?.siret
      + Endpoints.PREFERENCE_SERVICE
      + this.session.getUser()?.service
      + Endpoints.PREFERENCE_RAISON_SOCIALE
      + this.session.getUser()?.raisonSociale
      , body
      , Preference
    );
  }

  public updateCpv(preference: Preference): Observable<Preference> {
    if (!this.isPrefActivated) {
      return of(new Preference());
    }
    const body = preference;
    return this.http.put(
      Endpoints.PREFERENCE_CPV
      , body
      , Preference
    );
  }

  public getFullCpv(): Observable<Preference[]> {
    if (!this.isPrefActivated) {
      return of([new Preference()]);
    }
    return this.http.get<Preference[], Preference>(
      Endpoints.PREFERENCE_CPV_FULL
      + Endpoints.PREFERENCE_SIRET
      + this.session.getUser()?.siret
      + Endpoints.PREFERENCE_SERVICE
      + this.session.getUser()?.service
      , Preference
    );
  }

  public getlightCpv(): Observable<Preference[]> {
    if (!this.isPrefActivated) {
      return of([new Preference()]);
    }
    return this.http.get<Preference[], Preference>(
      Endpoints.PREFERENCE_CPV_LIGHT
      + Endpoints.PREFERENCE_SIRET
      + this.session.getUser()?.siret
      + Endpoints.PREFERENCE_SERVICE
      + this.session.getUser()?.service
      , Preference
    );
  }

  public getByIdCpv(id: string): Observable<Preference> {
    if (!this.isPrefActivated) {
      return of(new Preference());
    }
    return this.http.get(
      Endpoints.PREFERENCE_CPV
      + '/' + id
      , Preference
    );
  }

  public deleteCpv(id: number): Observable<any> {
    if (!this.isPrefActivated) {
      return of(null);
    }
    return this.http.delete(
      Endpoints.PREFERENCE_CPV
      + Endpoints.PREFERENCE_ID
      + id
    );
  }

  // preference logo
  public createLogo(file: File): Observable<File> {
    if (!this.isPrefActivated) {
      return null;
    }
    const data: FormData = new FormData();
    data.append('file', file);

    return this.http.postMultipart<File, File>(
      Endpoints.PREFERENCE_LOGO
      + Endpoints.PREFERENCE_SIRET
      + this.session.getUser()?.siret
      + Endpoints.PREFERENCE_SERVICE
      + this.session.getUser()?.service
      + Endpoints.PREFERENCE_RAISON_SOCIALE
      + this.session.getUser()?.raisonSociale
      , data
    );
  }

  public getLogoFull(): Observable<Preference[]> {
    if (!this.isPrefActivated) {
      return of([new Preference()]);
    }
    return this.http.get<Preference[], Preference>(
      Endpoints.PREFERENCE_LOGO_FULL
      + Endpoints.PREFERENCE_SIRET
      + this.session.getUser()?.siret
      + Endpoints.PREFERENCE_SERVICE
      + this.session.getUser()?.service
      , Preference
    );
  }

  public getLogoLight(): Observable<Preference[]> {
    if (!this.isPrefActivated) {
      return of([new Preference()]);
    }
    return this.http.get<Preference[], Preference>(
      Endpoints.PREFERENCE_LOGO_LIGHT
      + Endpoints.PREFERENCE_SIRET
      + this.session.getUser()?.siret
      + Endpoints.PREFERENCE_SERVICE
      + this.session.getUser()?.service
      , Preference
    );
  }

  public deleteLogo(): Observable<any> {
    if (!this.isPrefActivated) {
      return of(new Preference());
    }
    return this.http.delete(
      Endpoints.PREFERENCE_LOGO
      + Endpoints.PREFERENCE_SIRET
      + this.session.getUser()?.siret
      + Endpoints.PREFERENCE_SERVICE
      + this.session.getUser()?.service
    );
  }

  // preference diffuseur
  public createDiffuseur(preference: Preference): Observable<Preference> {
    if (!this.isPrefActivated) {
      return of(new Preference());
    }
    const body = preference;
    return this.http.post(
      Endpoints.PREFERENCE_DIFFUSEUR
      + Endpoints.PREFERENCE_SIRET
      + this.session.getUser()?.siret
      + Endpoints.PREFERENCE_SERVICE
      + this.session.getUser()?.service
      + Endpoints.PREFERENCE_RAISON_SOCIALE
      + this.session.getUser()?.raisonSociale
      , body
      , Preference
    );
  }

  public updateDiffuseur(preference: Preference): Observable<Preference> {
    if (!this.isPrefActivated) {
      return of(new Preference());
    }
    const body = preference;
    return this.http.put(
      Endpoints.PREFERENCE_DIFFUSEUR
      , body
      , Preference
    );
  }

  public getFullDiffuseur(): Observable<Preference[]> {
    if (!this.isPrefActivated) {
      return of([new Preference()]);
    }
    return this.http.get<Preference[], Preference>(
      Endpoints.PREFERENCE_DIFFUSEUR_FULL
      + Endpoints.PREFERENCE_SIRET
      + this.session.getUser()?.siret
      + Endpoints.PREFERENCE_SERVICE
      + this.session.getUser()?.service
      , Preference
    );
  }

  public getlightDiffuseur(): Observable<Preference[]> {
    if (!this.isPrefActivated) {
      return of([new Preference()]);
    }
    return this.http.get<Preference[], Preference>(
      Endpoints.PREFERENCE_DIFFUSEUR_LIGHT
      + Endpoints.PREFERENCE_SIRET
      + this.session.getUser()?.siret
      + Endpoints.PREFERENCE_SERVICE
      + this.session.getUser()?.service
      , Preference
    );
  }

  public getByIdDiffuseur(id: string): Observable<Preference> {
    if (!this.isPrefActivated) {
      return of(new Preference());
    }
    return this.http.get(
      Endpoints.PREFERENCE_DIFFUSEUR
      + '/' + id
      , Preference
    );
  }

  public deleteDiffuseur(id: number): Observable<any> {
    if (!this.isPrefActivated) {
      return of(null);
    }
    return this.http.delete(
      Endpoints.PREFERENCE_DIFFUSEUR
      + Endpoints.PREFERENCE_ID
      + id
    );
  }

  public getAllDatasDiffuseurs(): Observable<Diffuseur[]> {
    return this.http.get<Diffuseur[], Diffuseur>(
      Endpoints.DIFFUSEUR_FINDALL
      + Endpoints.PREFERENCE_SIRET
      + this.session.getUser()?.siret
      + Endpoints.PREFERENCE_SERVICE
      + this.session.getUser()?.service,
      Diffuseur
    );
  }

  // preference acheteur
  public createAcheteur(preference: Preference): Observable<Preference> {
    if (!this.isPrefActivated) {
      return of(new Preference());
    }
    const body = preference;
    return this.http.post(
      Endpoints.PREFERENCE_ACHETEUR
      + Endpoints.PREFERENCE_SIRET
      + this.session.getUser()?.siret
      + Endpoints.PREFERENCE_SERVICE
      + this.session.getUser()?.service
      + Endpoints.PREFERENCE_RAISON_SOCIALE
      + this.session.getUser()?.raisonSociale
      , body
      , Preference
    );
  }

  public updateAcheteur(preference: Preference): Observable<Preference> {
    if (!this.isPrefActivated) {
      return of(new Preference());
    }
    const body = preference;
    return this.http.put(
      Endpoints.PREFERENCE_ACHETEUR
      , body
      , Preference
    );
  }

  public getFullAcheteur(): Observable<Preference[]> {
    if (!this.isPrefActivated) {
      return of([new Preference()]);
    }
    return this.http.get<Preference[], Preference>(
      Endpoints.PREFERENCE_ACHETEUR_FULL
      + Endpoints.PREFERENCE_SIRET
      + this.session.getUser()?.siret
      + Endpoints.PREFERENCE_SERVICE
      + this.session.getUser()?.service
      , Preference
    );
  }

  public getlightAcheteur(): Observable<Preference[]> {
    if (!this.isPrefActivated) {
      return of([new Preference()]);
    }
    return this.http.get<Preference[], Preference>(
      Endpoints.PREFERENCE_ACHETEUR_LIGHT
      + Endpoints.PREFERENCE_SIRET
      + this.session.getUser()?.siret
      + Endpoints.PREFERENCE_SERVICE
      + this.session.getUser()?.service
      , Preference
    );
  }

  public getByIdAcheteur(id: string): Observable<Preference> {
    if (!this.isPrefActivated) {
      return of(new Preference());
    }
    return this.http.get(
      Endpoints.PREFERENCE_ACHETEUR
      + '/' + id
      , Preference
    );
  }

  public deleteAcheteur(id: number): Observable<any> {
    if (!this.isPrefActivated) {
      return of(null);
    }
    return this.http.delete(
      Endpoints.PREFERENCE_ACHETEUR
      + Endpoints.PREFERENCE_ID
      + id
    );
  }
}
